// ImageService.js

import images from './bundledArticleImages';
import logo from '../images/logo.jpg';

const findArticleImage = (article) => {
  // Legacy photos were bundled under the original codes, which the catalog
  // retains as barcodes. Editing the displayed code must not change the photo.
  for (const reference of [article?.imageSource, article?.barcode, article?.code]) {
    if (reference === null || reference === undefined || reference === '') continue;
    const key = String(reference).trim();
    for (const filename of [key, `${key}.jpg`, `${key}.png`, `${key}.jpeg`, `${key}.svg`]) {
      if (Object.prototype.hasOwnProperty.call(images, filename)) {
        return images[filename];
      }
    }
  }
  return logo;
};

const ImageService = {
  findArticleImage,
};

export default ImageService;
